import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/deployments/inferenceCheck';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { inferenceId } = action?.payload || {};
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/inference/${inferenceId}`,
      { headers: getLocalUser() },
    );
    // The record only exists once the inference succeeded — echo the id
    // so the page can navigate straight to /inferences/<uid>.
    yield put(fetchSuccess({
      inference_id: inferenceId,
      data: response?.data?.data ?? response?.data ?? null,
    }));
  } catch (error) {
    // Still pending (no record yet) or failed — the page keeps waiting
    // and its safety timeout bounds the spinner, so stay silent here.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
